export default __webpack_public_path__ + "static/media/pic3.299a4176.jpg";